export default __webpack_public_path__ + "static/media/polygon_logo.d9c57bf9.svg";